var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    fill: "none",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e44d26",
    d: "M42.734 163.933 30 21h140l-12.734 142.856-57.382 15.898"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f16529",
    d: "M100 167.6V32.732h57.227l-10.921 121.941"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M56.009 50.212H100v17.52H75.226l1.62 17.943H100v17.481H60.794zm5.557 61.742h17.596l1.235 14.008L100 131.21v18.291l-35.965-10.033"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M143.836 50.212H99.922v17.52h42.293zm-3.203 35.463H99.922v17.52h21.61l-2.046 22.767-19.564 5.248v18.214l35.887-9.956"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5);
export default __webpack_public_path__ + "static/media/html5.85b54d8c0cc00cc04218f6176c7c77e3.svg";
export { ForwardRef as ReactComponent };